import { initialState } from "../user.slice"

const userExit = () => {
    return initialState;
}

export default userExit;